
type Handler = (data: any) => void;

export class CognitoMessaging {
	private _handlers: Record<string, Handler[]> = {};

	constructor() {
		const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
		const event = window.addEventListener ? 'message' : 'onmessage';
		const eventer = window[eventMethod];
		eventer(event, this._handle, false);

		// this._addDefualtEventHandler();
	}

	// Get the value at the specified property path
	evalPath = (obj: any, path: string) => {
		function index(obj, i) { return obj[i]; }
		return path.split('.').reduce(index, obj);
	};

	_handle = (event: any) => {
		let payload;
		try {
			payload = JSON.parse(event.data);
		}
		catch (e) { }

		if (payload && payload.event) {
			const handlerList = this._handlers[payload.event];

			if (handlerList) {
				handlerList.forEach(function (handler) {
					handler.call(event, payload.data);
				});
			}
		}
	};

	_addDefualtEventHandler = () => {
		const defaultEventHandler = (data: any) => {
			// TODO: do we need to serialize or cleanse the args while in vue?
			// Might just need to prevent observability
			this.evalPath(window, data.scope)[data.fn].apply(window, data.args);
		};
		this.addHandler('proxy', defaultEventHandler);
	};

	/**
	 * Adds a handler for the specified event.
	 * @param name The name of the event.
	 * @param handler The handler function.
	 * @returns A function used to unsubscribe the event handler.
	 */
	addHandler = (name: string, handler: Handler) => {
		this._handlers[name] = this._handlers[name] || [];
		this._handlers[name].push(handler);

		return () => this.removeHandler(name, handler);
	};

	removeHandler = (name: string, handler: Handler) => {
		const handlers = (this._handlers[name] || []);
		const idx = handlers.indexOf(handler);
		if (idx >= 0)
			handlers.splice(idx, 1);
	};

	trigger = (event: string, options?: {target?: Window, origin?: string, data?: any}) => {
		const payload = {};
		payload['event'] = event;

		if (options && options.data) {
			payload['data'] = options.data;
		}

		const target = (options && options.target) || window.parent;
		const origin = (options && options.origin) || '*';

		target.postMessage(JSON.stringify(payload), origin);
	};

	// // Creates a proxy for a set of functions that can be safely called across frame boundaries
	proxy = (target: Window, scope: string) => {
		// Get the function set for the specified target and scope
		const fnSet = this.evalPath(target, scope);
		const proxy = {};

		// Define a closure to create a proxy wrapper function
		function createProxy(fn) {
			return function (...args) {
				this.trigger('proxy', { target: target, data: { scope: scope, fn: fn, args: args } });
			};
		}

		if (typeof fnSet === 'function' || !fnSet) {
			return fnSet;
		}
		// Create proxy functions for each function in the set
		else {
			for (const fn in fnSet) {
				proxy[fn] = createProxy(fn);
			}
		}

		return proxy;
	};
}
const cognitoMessenger = new CognitoMessaging();
export default cognitoMessenger;